import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { api } from '../api.js';
import { useAuth } from '../auth.jsx';
import { useI18n } from '../i18n/index.jsx';
import Icon from '../components/Icon.jsx';
import { useSlugPresence } from './Presence.jsx';

// "Chat with the seller" (product page) / "Send a message" (company
// page): opens or continues the conversation in My account > Messages.
// Visitors are sent to sign in first; hidden on your own product/page and
// for admins (the team writes from Admin > Messages).
// repId: "Contacter" on a member of the company's public team (the chat goes to that rep).
export default function StartChatButton({ listingId, sellerSlug, ownerSlug, label, repId, className = 'btn btn-ghost btn-block' }) {
  const { t, errorText } = useI18n();
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const status = useSlugPresence(ownerSlug || sellerSlug);
  // Admins write from Admin > Messages; PME representatives from their workspace.
  if (user && (user.role === 'admin' || (ownerSlug && user.slug === ownerSlug) || (user.team?.pme && user.team?.isPerson))) return null;
  if (!user) return <Link className={className} to={`/login?next=${encodeURIComponent(location.pathname)}`}><Icon name="chat" size={18} /> {label || t('chat.chatWithSeller')}</Link>;
  async function start() {
    setBusy(true); setError('');
    try {
      const r = await api('/chat/conversations', { method: 'POST', body: listingId ? { listingId } : { sellerSlug, ...(repId ? { repId } : {}) } });
      navigate(`/account/messages/${r.id}`);
    } catch (e) { setError(errorText(e)); setBusy(false); }
  }
  return (
    <>
      <button type="button" className={className} onClick={start} disabled={busy}>
        <Icon name="chat" size={18} /> {label || t('chat.chatWithSeller')}
        {status?.online && <span className="online-badge"><span className="presence-dot is-online" aria-hidden="true" /> {t('presence.online')}</span>}
      </button>
      {error && <p className="field-error small">{error}</p>}
    </>
  );
}
